export default __webpack_public_path__ + "static/2-f38ea0b39d0940fb167b0e6cc461646b.png";